import { useState } from 'react';

export interface UseWalkThroughTableUiStateReturn {
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;

  isPdfLoading: boolean;
  setIsPdfLoading: (value: boolean) => void;

  previewItem: any | null;
  openPreview: (item: any) => void;
  closePreview: () => void;
}

export const useWalkThroughTableUiState = (): UseWalkThroughTableUiStateReturn => {
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [isPdfLoading, setIsPdfLoading] = useState<boolean>(false);
  const [previewItem, setPreviewItem] = useState<any | null>(null);

  const onSearchQueryChange = (value: string): void => {
    setSearchQuery(value);
  };

  const openPreview = (item: any): void => {
    setPreviewItem(item);
  };

  const closePreview = (): void => {
    setPreviewItem(null);
  };

  return {
    searchQuery,
    onSearchQueryChange,

    isPdfLoading,
    setIsPdfLoading,

    previewItem,
    openPreview,
    closePreview,
  };
};